<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon>
            <i class="fa-file-invoice-dollar fa-fw" :class="{'fas': active, 'far': !active}"></i>
        </template>
        <template v-slot:content>
            <section>
                <div class="tile-title">R{{plan.id}} - {{plan.users.last_name}}, {{plan.users.first_name}}</div>
                <div class="meta mt-1">
                    <i class="fas fa-tag mr-2 fa-fw"></i>{{ formatCurrency(plan.tax_amount) }}
                </div>
                <div class="meta">
                    <i class="fas fa-map-marker-alt mr-2 fa-fw"></i>{{plan.tax_jurisdiction || 'N/A'}} ({{plan.tax_location_code || 'N/A'}})
                </div>
                <div class="meta">
                    <i class="fas fa-percentage mr-2 fa-fw"></i>{{ formatPercent(plan.tax_rate) }} Tax Rate
                </div>
            </section>

            <div class="meta mt-2" v-if="plan.tax_result_code >= 6">
                <b-tag type="is-warning is-light">
                    <i class="fas fa-warning fa-fw mr-2"></i>{{ taxResultMessage }}
                </b-tag>
            </div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <b-tooltip v-if="plan.tax_result_code >= 6" label="Tax Lookup Issue" position="is-left" class="stat mr-1">
                    <i class="fas fa-warning has-text-warning"></i>
                </b-tooltip>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <div class="data mt-1">
                    <data-row mini title="Plan ID">R{{plan.id}}</data-row>
                    <data-row mini title="User">{{plan.users.first_name}} {{plan.users.last_name}}</data-row>
                    <data-row mini title="Email">{{plan.users.email}}</data-row>
                    <data-row mini title="State">{{plan.users.state}}</data-row>
                    <data-row mini title="City">{{plan.users.city}}</data-row>
                    <data-row mini title="Plan Total">{{ formatCurrency(plan.total) }}</data-row>
                    <data-row mini title="Agreement Total">{{ formatCurrency(plan.agreement_total) }}</data-row>
                    <data-row mini title="Jurisdiction">{{plan.tax_jurisdiction || 'N/A'}}</data-row>
                    <data-row mini title="Location Code">{{plan.tax_location_code || 'N/A'}}</data-row>
                    <data-row mini title="Tax Rate">{{ formatPercent(plan.tax_rate) }}</data-row>
                    <data-row mini title="Tax Amount">{{ formatCurrency(plan.tax_amount) }}</data-row>
                    <data-row mini title="Tax Paid">{{ formatCurrency(plan.tax_paid) }}</data-row>
                    <data-row mini title="Tax Owed">{{ formatCurrency(plan.tax_owed) }}</data-row>
                    <data-row mini title="Calculated">{{plan.tax_calculated_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import numeral from "numeral";

    export default {
        name: 'TaxPlanTile',
        components: {CardListItem, DataRow},
        props: {
            card: {
                required: true
            },
            plan: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            taxResultMessage() {
                const code = this.plan.tax_result_code;
                if (code === 6) return 'Address/ZIP not found';
                if (code === 7) return 'Invalid coordinates';
                if (code === 9) return 'Internal error';
                return 'Tax lookup issue';
            }
        },
        methods: {
            formatCurrency(value) {
                return numeral(value).format('$0,0.00');
            },
            formatPercent(value) {
                return numeral(value * 100).format('0.000') + '%';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .tax-summary {
        background: #f8f9fa;
        padding: 0.75rem;
        border-radius: 4px;

        .tax-line {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.25rem;

            &:last-child {
                margin-bottom: 0;
                padding-top: 0.25rem;
                border-top: 1px solid #dee2e6;
            }

            .tax-label {
                font-size: 0.85rem;
            }

            .tax-value {
                font-size: 0.85rem;
                font-weight: 600;
            }
        }
    }
</style>
